<div
  data-testid="block-patient"
  [ngClass]="{
    'aspect-video': aspectVideo,
    'shadow-sm transition-shadow hover:shadow-md': card,
    'p-2': cardPadding,
    'w-full': widthFull
  }"
  class="flex flex-row items-center flex-1 gap-1 transition-colors rounded-md cursor-pointer relative"
  (click)="select.emit()"
  [ngStyle]="{ 'background-color': card ? bgColor() : 'transparent' }"
>
  @switch (layout) {
    @case ("minimal") {
      <div class="flex flex-row items-center gap-0.5">
        @if (patient.deceased) {
          <div class="flex items-center justify-center w-4 h-4">
            <i class="fa-light fa-tombstone"></i>
          </div>
        }

        <div class="flex items-center justify-center w-4 h-4">
          <i class="{{ speciesIconClass }}"></i>
        </div>

        <span
          class="text-sm text-slate-900"
          [ngClass]="{ underline: underlineName }"
        >
          {{ patient.name }}
        </span>
      </div>
    }

    @case ("default") {
      <div [ngClass]="{ 'flex-1': widthFull }" class="flex flex-row gap-1">
        @if (showLargeSpeciesIcon) {
          <div class="flex">
            <div class="flex items-center justify-center flex-1 relative">
              <i
                class="{{
                  patient.species | speciesIcon
                }} text-2xl text-slate-400"
              ></i>

              @if (labelSex) {
                <div
                  class="absolute -bottom-1 -right-1 flex items-center justify-center w-4 h-4"
                >
                  @switch (labelSex) {
                    @case ("male") {
                      <i class="fa-solid fa-duotone fa-mars text-blue-600"></i>
                    }
                    @case ("female") {
                      <i class="fa-solid fa-duotone fa-venus text-pink-600"></i>
                    }
                  }
                </div>
              }
            </div>
          </div>
        }

        <div class="flex flex-col flex-1 whitespace-nowrap">
          <!-- first line: deceased, sex, name -->
          <div class="flex flex-row items-center gap-0.5">
            @if (patient.deceased) {
              <div class="flex items-center justify-center w-4 h-4">
                <i class="fa-light fa-tombstone"></i>
              </div>
            }

            @if (labelSex && !showLargeSpeciesIcon) {
              <div class="flex items-center justify-center w-4 h-4">
                @switch (labelSex) {
                  @case ("male") {
                    <i class="fa-light fa-mars text-slate-400"></i>
                  }
                  @case ("female") {
                    <i class="fa-light fa-venus text-slate-400"></i>
                  }
                  @default {
                    <i class="fa-light fa-circle-question text-slate-400"></i>
                  }
                }
              </div>
            }

            @if (!wrapPatientName) {
              <span
                class="text-xs text-slate-900"
                [ngClass]="{ underline: underlineName }"
                [title]="patient.name"
              >
                {{ patient.name }}
              </span>
            } @else {
              <div class="flex-1 relative">
                <span class="text-xs">&nbsp;</span>

                <div class="absolute inset-0 truncate text-slate-900">
                  <span class="text-xs" [title]="patient.name">{{
                    patient.name
                  }}</span>
                </div>
              </div>
            }

            @if (showNumber) {
              <div class="ml-auto">
                <span class="text-xxs uppercase text-slate-400">
                  {{ patient.number || "" }}
                </span>
              </div>
            }
          </div>

          <!-- second line: species & breed -->
          <div class="flex flex-row gap-0.5">
            @if (labelSpeciesBreed && !showLargeSpeciesIcon) {
              <div class="flex items-center justify-center w-4 h-4">
                <i class="{{ speciesIconClass }}"></i>
              </div>
            }

            @if (labelSpeciesBreed) {
              <div class="flex flex-row items-center">
                <span class="text-xs text-slate-900">{{
                  labelSpeciesBreed
                }}</span>
              </div>
            }

            @if (labelAge) {
              <div class="flex flex-row items-center">
                <span class="text-xxs text-slate-400">{{ labelAge }}</span>
              </div>
            }

            @if (showMicrochip && patient.microchip) {
              <div>
                <span class="text-xxs text-slate-400">{{
                  patient.microchip
                }}</span>
              </div>
            }

            @if (showCreatedAt && patient.createdAt) {
              <div class="ml-auto">
                <span class="text-xxs italic text-slate-400">
                  {{
                    "Inserito il [date]"
                      | transloco: { date: patient.createdAt | dayjs: "L" }
                  }}
                </span>
              </div>
            }
          </div>

          <!-- owner -->
          @if (showOwner) {
            <div>
              <span class="text-xs text-slate-900">{{
                patient.owner | customerNominative
              }}</span>
            </div>
          }

          @if (enableLastAppointmentDate) {
            <div>
              @if (loadingLastAppointment()) {
                <span class="text-xs text-slate-400">...</span>
              } @else {
                @if (lastAppointmentDate()) {
                  <span class="text-xs text-slate-900"
                    >{{ "Ultimo appuntamento il" | transloco }}
                    {{ lastAppointmentDate() }}</span
                  >
                } @else {
                  <span class="text-xs text-slate-400"
                    >{{ "Nessun appuntamento inserito" | transloco }}
                  </span>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  }

  @if (enableEdit) {
    <!-- TODO: verificare se questo blocco serve davvero -->
    @if (false) {
      <div class="flex items-end justify-end p-1 absolute top-0 right-0">
        <div #button>
          <snt-button-icon
            [sntTooltip]="rowActionsTemplate"
            [placement]="'right'"
            icon="fa-light fa-ellipsis-vertical"
          >
          </snt-button-icon>
        </div>
        <ng-template #rowActionsTemplate>
          <div class="flex flex-col gap-1 p-1">
            <snt-button
              [title]="'Modifica' | transloco"
              icon="fa-light fa-pen"
              (onClick)="onEdit(patient); popover.instance.hide()"
            ></snt-button>
            <snt-button
              [title]="'Elimina' | transloco"
              icon="fa-light fa-trash"
              (onClick)="onDelete(patient); popover.instance.hide()"
            ></snt-button>
          </div>
        </ng-template>
        <dx-popover
          #popover
          [target]="button"
          [hideOnOutsideClick]="true"
          position="top"
        >
          <div
            (mouseleave)="popover.instance.hide()"
            *dxTemplate="let data = model of 'content'"
            class="flex flex-col gap-1 p-1"
          >
            <snt-button
              [title]="'Modifica' | transloco"
              icon="fa-light fa-pen"
              (onClick)="onEdit(patient); popover.instance.hide()"
            ></snt-button>
            <snt-button
              [title]="'Elimina' | transloco"
              icon="fa-light fa-trash"
              (onClick)="onDelete(patient); popover.instance.hide()"
            ></snt-button>
          </div>
        </dx-popover>
      </div>
    }
  }
</div>
